import { render, staticRenderFns } from "./SortModal.vue?vue&type=template&id=55b0a697"
import script from "./SortModal.vue?vue&type=script&lang=js"
export * from "./SortModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports